import { FRONTIER_SECRETS } from './frontier';

export interface Place { id: string; name: string; subtitle: string; x: number; z: number; color: string; story: string; }
export interface Find { id: string; name: string; kind: 'crumb' | 'sugar' | 'button'; x: number; z: number; }

export const SPAWN = { x: -104, z: 52 };
export const PLACES: Place[] = [
  { id: 'terrace', name: 'The café terrace', subtitle: 'A world beneath the table', x: -104, z: 52, color: '#dc985c', story: 'Somewhere above you, a coffee is getting cold. Down here, breakfast is a mountain range.' },
  { id: 'napkin', name: 'Cotton mountains', subtitle: 'Across the fallen napkin', x: -65, z: 30, color: '#b07582', story: 'A tablecloth caught on a stone. To anyone else, a small accident. To you, a new passage.' },
  { id: 'lake', name: 'The little big lake', subtitle: 'Find a way around the water', x: -30, z: 42, color: '#5faaaa', story: 'Yesterday’s rain has become an entire lake. A fallen leaf makes an excellent bridge.' },
  { id: 'roots', name: 'The green cathedral', subtitle: 'Between the planter roots', x: 8, z: -4, color: '#7c9b59', story: 'Sunlight filters through a canopy of grass. An ordinary planter holds a wilderness.' },
  { id: 'bench', name: 'The forgotten corner', subtitle: 'Treasures under the bench', x: 54, z: -12, color: '#ba8963', story: 'A red button, a quiet corner, and the soft footsteps of other explorers.' },
  { id: 'louvre', name: 'The Louvre', subtitle: 'A very small visitor. A very big arrival.', x: 105, z: -38, color: '#75b8bd', story: 'You crossed mountains of cotton and a lake of rain. Now the glass pyramid belongs in your collection of firsts.' },
];
export const FINDS: Find[] = [
  { id: 'crumb-evening-1', kind: 'crumb', name: 'Evening biscuit crumb', x: 216, z: -18 },
  { id: 'crumb-evening-2', kind: 'crumb', name: 'Lamplight flake', x: 211, z: -16 },
  { id: 'crumb-evening-3', kind: 'crumb', name: 'Sleepy supper crumb', x: 208, z: -14 },
  { id: 'crumb-1', kind: 'crumb', name: 'Croissant flake', x: -101, z: 51 },
  { id: 'crumb-2', kind: 'crumb', name: 'Breakfast crumb', x: -95, z: 46 },
  { id: 'sugar-1', kind: 'sugar', name: 'Café sugar crystal', x: -118, z: 42 },
  { id: 'crumb-3', kind: 'crumb', name: 'Golden crust', x: -82, z: 36 },
  { id: 'sugar-2', kind: 'sugar', name: 'Napkin nook crystal', x: -66, z: 22 },
  { id: 'crumb-4', kind: 'crumb', name: 'Picnic crumb', x: -53, z: 36 },
  { id: 'crumb-5', kind: 'crumb', name: 'Lakeside flake', x: -34, z: 46 },
  { id: 'sugar-3', kind: 'sugar', name: 'Rain-polished crystal', x: -22, z: 38 },
  { id: 'crumb-6', kind: 'crumb', name: 'Baguette crumb', x: -8, z: 13 },
  { id: 'crumb-7', kind: 'crumb', name: 'Garden crumb', x: 8, z: 3 },
  { id: 'sugar-4', kind: 'sugar', name: 'Root hollow crystal', x: 17, z: -15 },
  { id: 'crumb-8', kind: 'crumb', name: 'Bench-side crust', x: 35, z: -6 },
  { id: 'button', kind: 'button', name: 'The lost red button', x: 52, z: -23 },
  { id: 'crumb-9', kind: 'crumb', name: 'Courtyard crumb', x: 76, z: -27 },
  { id: 'crumb-10', kind: 'crumb', name: 'Last little flake', x: 94, z: -34 },
];
export const CAT_SECRET = { id: 'grumpy-guardian', name: 'The Grumpy Guardian', x: 48, z: 11 };
export const SECRETS = [
  ...FRONTIER_SECRETS,
  { id: 'sleepy-gathering', name: 'The sleepy supper club', x: 205, z: -14 },
  { id: 'evening-teacup', name: 'A thimble of imaginary tea', x: 229, z: -9 },
  { id: 'fountain-sparkle', name: 'A water-polished jewel', x: 225, z: 68 },
  { id: 'fountain-moss', name: 'The moss umbrella', x: 205, z: 82 },
  { id: 'fountain-coin', name: 'A forgotten fountain coin', x: 230, z: 60 },
  { id: 'artist-sketch', name: 'A sketch of the Grumpy Guardian', x: 322, z: 10 },
  { id: 'artist-palette', name: 'The four-color hill', x: 303, z: 16 },
  { id: 'artist-cap', name: 'The lost paint cap', x: 298, z: 34 },
  { id: 'picnic-pocket', name: 'The hidden diamond ring', x: 278, z: 70 },
  CAT_SECRET,
  { id: 'fold', name: 'Behind the fold', x: -66, z: 22 },
  { id: 'crack', name: 'The pavement passage', x: -44, z: 55 },
  { id: 'hollow', name: 'The root hollow', x: 17, z: -15 },
];
